const formatCardNumber = (card_num: string): string => {
  const firstNum = card_num.substring(0, 4);
  const secondNum = card_num.substring(4, 8);
  const thirdNum = card_num.substring(8, 12);
  const lastNum = card_num.substring(12);
  return `${firstNum}-${secondNum}-${thirdNum}-${lastNum}`;
};

export default formatCardNumber;
